export const SET_KIDS = 'SET_KIDS';
export const SET_GRADES = 'SET_GRADES';
export const SET_HOME_GRADES = 'SET_HOME_GRADES';
export const SET_SUBJECTS = 'SET_SUBJECTS';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_BANNERS = 'SET_BANNERS';

const initialState = {
  kids: [],
  signupGrades: [],
  grades: [],
  subjects: [],
  packages: [],
  banners: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_KIDS:
      return {
        ...state,
        kids: action.payload.data,
      };

    case SET_GRADES:
      return {
        ...state,
        grades: action.payload.data,
      };

    case SET_HOME_GRADES:
      return {
        ...state,
        signupGrades: action.payload.data,
      };

    case SET_SUBJECTS:
      return {
        ...state,
        subjects: action.payload.data,
      };

    case SET_PACKAGES:
      return {
        ...state,
        packages: action.payload.data,
      };

    case SET_BANNERS:
      return {
        ...state,
        banners: action.payload.data,
      };

    default:
      return state;
  }
}
